"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _ChangeEmitter2 = _interopRequireDefault(require("./ChangeEmitter"));

var _Item = _interopRequireDefault(require("./Item"));

var _DevTools = _interopRequireDefault(require("../utils/DevTools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Singleton = /*#__PURE__*/function (_ChangeEmitter) {
  _inherits(Singleton, _ChangeEmitter);

  var _super = _createSuper(Singleton);

  function Singleton() {
    var _this;

    _classCallCheck(this, Singleton);

    _this = _super.call(this);
    _this._item = null;

    _this.get = function () {
      return _this._item;
    };

    _this.clear = function () {
      _this._item = null;
    };

    _this.set = function (item) {
      _this._item = _Item["default"].wrap(item);

      if (_lodash["default"].isString(_this.constructor.storageKey) && _lodash["default"].isFunction(_this.constructor.toStorage)) {
        var storageData = _this.constructor.toStorage(_assertThisInitialized(_this));

        if (storageData) {
          localStorage.setItem(_this.constructor.storageKey, JSON.stringify(storageData));
        } else {
          localStorage.setItem(_this.constructor.storageKey, null);
        }
      }

      _this.emitChange();
    };

    _this.markUpdated = function () {
      _this._item = _this._item._.clone();

      _this.emitChange();
    };

    if (_lodash["default"].isString(_this.constructor.storageKey) && _lodash["default"].isFunction(_this.constructor.fromStorage)) {
      var storageData = localStorage.getItem(_this.constructor.storageKey);

      if (storageData) {
        try {
          _this.constructor.fromStorage(_assertThisInitialized(_this), JSON.parse(storageData));
        } catch (e) {// Ignoring JSON exception
        }
      }
    }

    Singleton.singletons.push(_assertThisInitialized(_this));
    return _this;
  }

  return Singleton;
}(_ChangeEmitter2["default"]);

Singleton.singletons = [];

_DevTools["default"].expose({
  Singleton: Singleton
});

var _default = Singleton;
exports["default"] = _default;